var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _path10, _line3, _line4, _line5, _polyline, _line6, _line7, _path11, _path12, _path13, _path14, _path15, _line8, _path16, _line9, _path17, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.64 256.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a8cff2;}.b{fill:#cf2359;}.c{fill:none;}.c,.d{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:10px;}.d{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268,144c.58-30.33-27.49-85.21-45-77-48.79,22.88-19.12,81-21,51-1.09-17.39-65.58-6.54-65,15,.21,7.72,6.34-5.24,11-19,6.48-19.14-34-57-51-44-6.69,5.13-13.49,9.69-17,60-6.53,93.72-2.78,78.5,2,84,14.33,16.47,41.4,58.81,40,25-.6-14.47,7,4.3,58-8,16.61-4,34.07,14.2,47,15,15.63,1,38.93-31.06,44-55C275.35,170.46,267.84,152.4,268,144Z",
    transform: "translate(-46 -61.53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M139,232c-10.75,1.67-19.43,22.1-27,54-1.24,5.21-5.58,21.11.19,25.34,7.65,5.61,19.07,2.14,26.77,0,19.62-5.46,41-7,60-14.34,49.41-19.11,49.27-9,55-22,4.5-10.19-17.49-16-19-18-7.11-9.3-23.87-19.12-37-24-36.62-13.6-22.24-18.14-22-3C176.21,243.1,155,229.52,139,232Z",
    transform: "translate(-46 -61.53)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 92,
    y: 174.47,
    width: 12,
    height: 29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 126,
    y: 182.47,
    width: 19,
    height: 12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M264.5,128.5s-11-72-49-60c0,0-16.5,3.5-27.5,53.5",
    transform: "translate(-46 -61.53)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M133.49,128.5C140,123,153,108,186,113",
    transform: "translate(-46 -61.53)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.87,128.5",
    transform: "translate(-46 -61.53)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.87,133.09s.7-58.79,19.92-65.94c0,0,23.58-9.72,53.89,48.06",
    transform: "translate(-46 -61.53)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.87,149.45s-32.31,65.7,36.91,103.12",
    transform: "translate(-46 -61.53)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M269,146s25,72-41,102",
    transform: "translate(-46 -61.53)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M179,224l61.11,34.91c-.26.09,18.58,7.66,10.95,20.29a7.79,7.79,0,0,1-4.75,3.49L126.85,313.11S106,317,112,296l13-63",
    transform: "translate(-46 -61.53)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 24,
    y1: 122.47,
    x2: 6,
    y2: 121.47
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 25,
    y1: 136.47,
    x2: 5,
    y2: 141.47
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M98,177",
    transform: "translate(-46 -61.53)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 190,
    y1: 125.47,
    x2: 209,
    y2: 123.47
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 191,
    y1: 139.47,
    x2: 210,
    y2: 143.47
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 92,
    y1: 180.47,
    x2: 88,
    y2: 212.47
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "88 213.47 106 197.47 108 175.47"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 166,
    y1: 201.47,
    x2: 125,
    y2: 195.47
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 132.55,
    y1: 178.47,
    x2: 166,
    y2: 201.47
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M171.45,255.38",
    transform: "translate(-46 -61.53)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M176,220c.26.8,6.51,20.58-18,18",
    transform: "translate(-46 -61.53)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M167,237.88C150.11,240,150.13,222,150,222",
    transform: "translate(-46 -61.53)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M150,222c-.81.05,0,18-18,15",
    transform: "translate(-46 -61.53)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M133,237c-.05,0-9.71-1-8.17-15",
    transform: "translate(-46 -61.53)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 92.2,
    y1: 229.76,
    x2: 148.91,
    y2: 215.68
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M194.91,277.25l-26.64-.68a7.81,7.81,0,0,0-3.64.79l-26.44,13.05",
    transform: "translate(-46 -61.53)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 125.06,
    y1: 177.8,
    x2: 125.06,
    y2: 194.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M194.82,177",
    transform: "translate(-46 -61.53)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 150.5,
    cy: 130.97,
    rx: 9.5,
    ry: 15.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 51.5,
    cy: 131.97,
    rx: 9.5,
    ry: 15.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d6c31af9.svg";
export { ForwardRef as ReactComponent };